module.exports = __webpack_public_path__ + "static/img/step3_img.f65bc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/step3_img.png
// module id = A7jm
// module chunks = 1